export const userQueryKeys = {
	currentAvatar: ['user', 'avatar', 'current'] as const,
	profile: ['user', 'profile'] as const,
	currentProfile: (userId: string) => ['user', 'profile', userId] as const,
}
